/* MMA – setzt auf <html> die Klasse „mma-cart-open“, solange der Cart Drawer geöffnet ist.
   Damit blendet assets/mma-cart.css den Klaviyo-Teaser und das Klaviyo-Pop-up aus, solange
   der Warenkorb offen ist. Es wird nichts an Klaviyo geändert, nur die Anzeige im Shop. */
(function () {
  if (window.MmaCartState) return;
  function init() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    const sync = () => document.documentElement.classList.toggle('mma-cart-open', drawer.classList.contains('active'));
    new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    sync();
    window.MmaCartState = { sync };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
